import { FormControl, Grid } from '@mui/material';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { officeApiKeyStore } from '../../../api/office-api-key-store';
import { FormRadioButtonGroup } from '../../../components/hook-form/form-radio-button-group.component';
import { Project, ProjectType } from '../../../models/project';
import { useFormContext } from 'react-hook-form';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { useEffect, useState } from 'react';

interface ProjectHeaderForm {
  changeProps: (type: string, value: any) => void;
  isEdit?: boolean;
  isChange?: boolean;
  officeID?: any;
  onCustomerLoading: (data: boolean) => void;
  onRebateValue: (rebateValue: string) => void;
}

export const ProjectHeaderForm = ({
  changeProps,
  isEdit,
  isChange,
  onCustomerLoading,
  onRebateValue,
}: ProjectHeaderForm) => {
  const { setValue, getValues, setError, clearErrors } = useFormContext();
  const [selectedOfficeID, setOfficeID] = useState<number>(getValues('office.officeID') ?? 0);

  const { data, isLoading } = useLoadData<ApiResponse<Project[]>>(projectsApiKeyStore.getProjects());

  const {
    data: officeData,
    isLoading: isOfficeLoading,
    isFetching,
  } = useLoadData<ApiResponse<any>>(officeApiKeyStore.getInheritOffice(selectedOfficeID), selectedOfficeID !== 0);

  useEffect(() => {
    setValue('builderCode', getValues('office.builderCode'));
  }, [getValues('office.builderCode')]);

  useEffect(() => {
    if (officeData) {
      setValue('syncWithDuxCustomer', selectedOfficeID ? officeData?.data?.isDuxSyncSuccess : false);
    }
  }, [officeData]);

  useEffect(() => {
    if (officeData && !isEdit) {
      setValue('rebates', selectedOfficeID ? (officeData?.data?.rebates as string) : '');
      setValue('rebateCompanies', null);
      setValue('syncWithDux', false);
    }
    onRebateValue(selectedOfficeID ? (officeData?.data?.rebates as string) : '');
    onCustomerLoading(isOfficeLoading || isFetching);
  }, [officeData, selectedOfficeID]);

  const handleProject = (value: any) => {
    const matchData = data?.data?.find((ele) => ele.projectName.toLocaleLowerCase() == value.toLocaleLowerCase());
    if (matchData) {
      setError('projectName', {
        type: 'custom',
        message: 'Project already exists',
      });
    } else {
      clearErrors('projectName');
    }
  };

  const handleProjectTypeChange = (value: ProjectType) => {
    if (value === ProjectType.TimeAndMaterial) {
      setValue('timeMaterials', [{ timeMaterialWork: '' }]);
      setValue('projectCommunityType', '');
      setValue('projectLotType', '');
    }
    if (value === ProjectType.Commercial) {
      setValue('projectCommunityType', '');
      setValue('projectLotType', '');
    }
    if (value === ProjectType.Residential) {
      setValue('projectCommunityType', '');
      setValue('projectLotType', '');
    }
  };

  const handleCustomerChange = (val: any) => {
    setValue('office', null);
    changeProps('customerID', val?.customerID);
  };

  const handleOfficeChange = (val: any) => {
    changeProps('officeID', val?.officeID);
    setOfficeID(val ? val?.officeID : 0);
    setValue('builderCode', val?.builderCode);
  };

  return (
    <>
      <Grid container spacing={1.5} style={{ marginBottom: '8px' }}>
        <Grid item lg={3} sm={3} xl={3} xs={3}>
          <FormAutoCompleteSelectDynamic
            name="customer"
            label="Customer"
            getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
            optionsValueKey="customerID"
            optionsLabelKey="customerName"
            onChange={handleCustomerChange}
            disabled={isEdit || isChange}
          />
        </Grid>
        <Grid item lg={3} sm={3} xl={3} xs={3}>
          <FormAutoCompleteSelectDynamic
            name="office"
            label="Office"
            watchKeys={['customer']}
            getQueryKeyConfig={(value: any) => officeApiKeyStore.getCustomerOffices(value.customer?.customerID)}
            optionsValueKey="officeID"
            optionsLabelKey="officeName"
            onChange={handleOfficeChange}
            disabled={isEdit || isChange}
          />
        </Grid>
        <Grid item lg={6} sm={6} xl={6} xs={6}>
          <FormControl className="spaceAroundChildContainer">
            <div>
              {' '}
              <FormRadioButtonGroup
                name="projectType"
                labelKey="label"
                valueKey="value"
                optionData={[
                  { label: 'Residential', value: ProjectType.Residential },
                  { label: 'Commercial', value: ProjectType.Commercial },
                  // { label: 'Time & Material', value: ProjectType.TimeAndMaterial },
                ]}
                onValueChange={handleProjectTypeChange}
                disable={isEdit}
              />
            </div>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
